import React, {
    PureComponent
  }                             from 'react';
import PropTypes              from 'prop-types';
import {
  AnimatedView,
  StatsCard,
  StatsTable,
  ScoreCard,
  StatsGraph,
  EarningGraph,
  Notifications,
  WorkProgress,
  TwitterFeed,
  TodoListDemo,
  TeamMatesDemo
}                         from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
  }                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import styles                 from './style'
import moment from 'moment';
import {Link}                 from 'react-router-dom';
import DatePicker from 'react-datepicker';

class Expenses extends PureComponent{
    static PropTypes = {
        actions: PropTypes.shape({
            enterPage: PropTypes.func,
            leavePage: PropTypes.func,
        })
    };

    constructor(props){
        super(props);
        this.state = {
            expense_id: props.match.params.id,
            payment_modes:{},
            categories:{},
            sub_categories:{},
            selected_category:'',
            selected_subcategory:'',
            venues: [],
            venue:'',
            bill_no:'',
            name:'',
            mode:'',
            amount:'',
            description:'',
            bill_no:'',
            selected_date: moment(),
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getExpenseDetails = this.getExpenseDetails.bind(this);
        this.handlebutton = this.handlebutton.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.getVenuesForBuddy = this.getVenuesForBuddy.bind(this);
        this.getExpenseRecord = this.getExpenseRecord.bind(this);
    }
    
    componentDidMount() {
         const {
          actions: {
            fetchStatsTableDataIfNeeded,
            fetchScoreCardDataIfNeeded,
          }
        } = this.props;

        console.log(this.state);
        console.log('this.props')
        console.log(this.props)

        this.getVenuesForBuddy();
        this.getExpenseDetails();
        this.getExpenseRecord();

        
    }

    handleDate(date){
      this.setState({selected_date:date});
      console.log(this.state.selected_date)
    }

    getExpenseDetails() {
        const url = `${getLocationOrigin()}/cm/get_details_for_expenses/`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {

            console.log('fuxk',data)
            this.setState(
            { 
                payment_modes:data.payment_modes,
                categories:data.category,
                sub_categories:data.sub_category
            });
    
           })
          .catch(error => error);
    }

    getExpenseRecord(){
        
        const url = `${getLocationOrigin()}/cm/get_records_for_expense/?expense_id=${this.state.expense_id}`;
        const options = {...defaultOptions};
        
        
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            console.log('helooo')
            console.log(data.expense_record.particulars)
            console.log(data.expense_record.amount)
                            

            this.setState({ venue:data.expense_record.venue,
                            amount:data.expense_record.amount,
                            mode:data.expense_record.payment_mode,
                            selected_date:moment(data.expense_record.date),
                            name:data.expense_record.particulars ,
                            bill_no:data.expense_record.bill_no,
                            description:data.expense_record.description,
                            selected_category : data.expense_record.category,
                            selected_subcategory: data.expense_record.sub_category
                            
                        });
    
           })
          .catch(error => {
             console.log('error');
             console.log(error)
           });

    }

    getVenuesForBuddy(){
        const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_buddy/`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            this.setState(
            { 
                
                venues:data.result,
                
                
            });
    
           })
          .catch(error => error);
    }

    postResponse() {

        const new_date = moment(this.state.selected_date).format("YYYY-MM-DD")
        const url = `${getLocationOrigin()}/cm/update_details_for_expenses/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                            'selected_date': new_date,
                            'expense_id':this.state.expense_id,
                            'venue':this.state.venue,
                            'name':this.state.name,
                            'amount':this.state.amount,
                            'mode':this.state.mode,
                            'bill_no':this.state.bill_no,
                            'description':this.state.description,
                            'category':this.state.selected_category,
                            'subcategory':this.state.selected_subcategory
                          });

        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(function(response){       
              console.log(response.Message)                           
              alert(response.Message);
              window.location.reload();
              })
          .catch(error => {
            console.log('error')
            console.log(error);
            alert(error.Message);
          });

    
    }

    handlebutton(){
        var new_val = {'name':'','amount':'','description':''};
        this.state.particulars.push(new_val);
    }

    handleChange(event) {
        const new_val = event.target;
        const name = new_val.name;
        console.log(new_val.value)
        if(name == 'venue'){
            this.setState({ venue:new_val.value})
        }
        else if(name == 'particular_name'){
            this.setState({name:new_val.value})
        }
        else if (name == 'category'){
            this.setState({selected_category:new_val.value})
        }
        else if(name == 'subcategory'){
            this.setState({selected_subcategory:new_val.value})
        }
        else if(name == 'mode'){
            this.setState({mode:new_val.value})
        }
        else if(name == 'amount'){
            this.setState({amount:new_val.value})
        }
        else if(name == 'Bill'){
            this.setState({bill_no:new_val.value})
        }
        else if(name == 'Description'){
            this.setState({description:new_val.value})
        }
    }

    handleSubmit(){
        event.preventDefault();
        console.log('post');
        this.btn.setAttribute("disabled", "disabled");
        this.postResponse();
        
    }

    render(){
        console.log('render')
        console.log(this.props)
        console.log(this.state)
       const {
          statsTable,
          scoreCard
        } = this.props;




        const {
              actions: {
                fetchStatsTableDataIfNeeded,
                fetchScoreCardDataIfNeeded,
              }
            } = this.props;
        return(
            <div className="row" style={styles.container}>
              <div className="row col-md-8 table-bordered" style={styles.table}>
                  <div style={styles.main_header} className='col-md-12 label_blue_1'>
                      <h3 style={{textAlign:'center'}}>Expenses</h3>
                  </div>
                  <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Venue
                        </div>
                        <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.venue}
                           onChange={this.handleChange} >
                            {
                               this.state.venues.map((venue, index) => (
                                  <option key={venue.id} value={venue.id}>{venue.name}</option>
                                ))
                             }
                         </select>
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Applicable Date
                          </div>
                          <DatePicker selected={this.state.selected_date} onChange={this.handleDate}/>
                           
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Name *
                          </div>
                          <input className="col-md-6" type= "text" name="particular_name" placeholder="Name of particular" onChange={this.handleChange} value={this.state.name}/>
                           
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Category
                          </div>
                          <select name="category" className="col-md-6" style={styles.item_body} value={this.state.selected_category}
                           onChange={this.handleChange}>
                            { 
                             Object.keys(this.state.categories).map((key,index)=>(
                               <option key={key} value={key}>{this.state.categories[key]}</option>
                              ))
                            }
                         </select>
                           
                      </div>

                      {this.state.selected_category == 10 &&
                          <div className="col-md-12" style={styles.items}>
                              <div className="col-md-6" style={styles.item_header}> 
                                  Sub Category
                              </div>
                                  
                              <select name="subcategory" className="col-md-6" style={styles.item_body} value={this.state.selected_subcategory}
                                  onChange={this.handleChange}>
                              {
                                  Object.keys(this.state.sub_categories).map((category, index) => (
                                  <option key={category} value={category}>{this.state.sub_categories[category]}</option>
                                ))
                              }
                              </select>
                              
                          </div>

                      }

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Mode Of Payment
                          </div>
                          <select name="mode" className="col-md-6" style={styles.item_body} value={this.state.mode}
                           onChange={this.handleChange}>
                            {
                               Object.keys(this.state.payment_modes).map((mode, index) => (
                                  <option key={mode} value={mode}>{this.state.payment_modes[mode]}</option>
                                ))
                             }
                         </select>      
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Amount *
                          </div>
                          <input className="col-md-6" type= "number" name="amount" placeholder="enter the amount"  onChange={this.handleChange} value={this.state.amount}/>
                           
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Bill No.
                          </div>
                          <input className="col-md-6" name="Bill" type= "text" placeholder="Bill no."  onChange={this.handleChange} value={this.state.bill_no}/>
                           
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Description *
                          </div>
                          <textarea className="col-md-6" rows="3" cols="20" name="Description" type= "text" placeholder="Description for this Expense" onChange={this.handleChange} value={this.state.description}/>
                           
                      </div>

                      <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
                          <div style={styles.button_submit} className="col-md-12">
                            <input className="button1" type="submit" value="Submit" onClick={this.handleSubmit}/>
                          </div>
                      </div>

                  </form>
              </div>
            </div>      
        );
    }
}

export default Expenses;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/editexpense/editExpenses.js